var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0594 13C13.0589 13 13.0583 13 13.0578 13C12.8686 13 12.6907 13.0676 12.5563 13.1903C12.4205 13.3145 12.3457 13.4798 12.3457 13.6557V23.4886C12.3457 23.8492 12.6671 24.1432 13.0623 24.1441C14.7281 24.1478 17.5191 24.4659 19.4445 26.312V16.0217C19.4445 15.8995 19.4104 15.7846 19.3461 15.6896C17.7659 13.3579 14.7291 13.0036 13.0594 13Z",
    fill: "#4251DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6534 23.4886V13.6557C27.6534 13.4798 27.5786 13.3145 27.4428 13.1903C27.3084 13.0676 27.1304 13 26.9414 13C26.9408 13 26.9402 13 26.9397 13C25.2701 13.0036 22.2333 13.3579 20.653 15.6897C20.5887 15.7847 20.5547 15.8995 20.5547 16.0218V26.312C22.4801 24.4659 25.2711 24.1478 26.9369 24.1441C27.332 24.1432 27.6534 23.8492 27.6534 23.4886Z",
    fill: "#4251DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2837 15.2676H28.7647V23.4886C28.7647 24.4092 27.9461 25.1599 26.9398 25.1622C25.5268 25.1653 23.1969 25.4184 21.5469 26.8493C24.4006 26.2091 27.409 26.6253 29.1235 26.9833C29.3375 27.0279 29.5588 26.9818 29.7303 26.8565C29.9012 26.7316 29.9992 26.5448 29.9992 26.3444V15.9232C29.9993 15.5617 29.6782 15.2676 29.2837 15.2676Z",
    fill: "#4251DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2345 23.4886V15.2676H10.7156C10.3211 15.2676 10 15.5617 10 15.9232V26.3442C10 26.5447 10.098 26.7314 10.269 26.8563C10.4403 26.9815 10.6613 27.0279 10.8758 26.9831C12.5902 26.625 15.5987 26.2089 18.4523 26.8491C16.8023 25.4183 14.4725 25.1652 13.0595 25.1621C12.0532 25.1599 11.2345 24.4092 11.2345 23.4886Z",
    fill: "#4251DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.8706c0f0d2ec869bc0be5f06c3aa620f.svg";
export { ForwardRef as ReactComponent };